import React, {ReactNode} from "react";
import {OfferType} from "../../../../../core/models/enums/offerType";
import "./Offer.scss";
import OfferLeading from "./OfferLeading/OfferLeading";
import OfferTrailing from "./OfferTrailing/OfferTrailing";

interface IProps {
  type: OfferType;
  body: ReactNode;
  onClick: () => void;
}

const Offer = (props: IProps) => {

  return (
    <div
      id="offer"
      className={props.type.toLowerCase()}
      onClick={() => props.onClick()}
    >
      <OfferLeading offerType={props.type}/>

      <div className="offer-body">
        {props.body}
      </div>

      <OfferTrailing offerType={props.type}/>
    </div>
  );
}

export default Offer;
